module.exports = __webpack_public_path__ + "static/media/free-mri.370f193b.svg";